import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../../base/base-mutation';
import { Rule } from '../../base/mutation-rules';
import { DataType } from '../../../data';
import { tableMergedRanges } from '../../../utils/table-utils';
import { MutationSource } from '../../../constants';
import type { IValidMutationData } from './../../../mutation/base';
import type { PresentationDataModel } from '../../../model/presentation-data-model';
import type { MaybeError } from '../../base/base-mutation';
import type { IValidMergeTableCellsMutationData } from '../../base/valid-mutation-data';
import type { ITableRangeData } from '@tencent/slide-sdk-pb-model';

export class MergeTableCellsMutation extends BaseMutation<PresentationDataModel, IValidMergeTableCellsMutationData> {
    public readonly type: MutationType = MutationType.MergeTableCells;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.shapeId) return;
        const { shapeId, range } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable)!;
        table.store.mergeTableCells(range);
    }

    public invert(presentation: PresentationDataModel): IValidMutationData[] {
        const { pageId, shapeId, range } = this.data;
        const table = presentation.store.models.get(shapeId, DataType.GraphicalObjectFrameTable);
        const mergedRanges: Required<ITableRangeData>[] = tableMergedRanges(table?.store.tableData || {}, range);
        const mergeTableCellsMutation = mergedRanges.map((range: Required<ITableRangeData>) => ({
            type: MutationType.MergeTableCells,
            pageId,
            shapeId,
            range,
        }));

        return [
            {
                type: MutationType.UnmergeTableCells,
                pageId,
                shapeId,
                range,
            },
            ...mergeTableCellsMutation,
        ];
    }

    public check(presentation: PresentationDataModel, source: MutationSource): MaybeError {
        const { pageId, shapeId, range } = this.data;
        if (source === MutationSource.Keyframe) {
            return Rule.every(Rule.shape.should.existInPage(presentation, shapeId, pageId));
        }
        return Rule.every(
            Rule.shape.should.existInPage(presentation, shapeId, pageId),
            Rule.table.can.mergeTableCells(presentation, shapeId, range),
            Rule.table.range.is.noMergedRange(presentation, shapeId, range),
        );
    }
}
